import React, { useEffect, useState } from 'react';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';
import { useAuth } from '../../context/Auth';
import { accessService } from '../../services/central-api/access';
import { StyleProp, TextStyle } from 'react-native';

type SetStateCallback<S> = ((prevState: S) => S);

interface Props {
    value: number;
    setValue: React.Dispatch<SetStateCallback<number>>;
    zIndex?: number;
    disabled?: boolean;
    labelFontSize?: number;
    label?: string;
    actingBodyId: number;
    allowEmpty?: boolean;
    labelStyle?: StyleProp<TextStyle>;
}

function OccurrenceTypeDropdown({ value, setValue, zIndex, disabled, labelFontSize, label, actingBodyId, labelStyle, allowEmpty = false }: Props) {
    const [items, setItems] = useState<{ label: string; value: number; }[]>([]);
    const { user: authenticatedUser } = useAuth();

    async function getOccurrenceTypes() {
        try {
            const response = await accessService.getDropDownOccurrenceTypes(actingBodyId);
            setItems([
                ...(allowEmpty ? [{ value: 0, label: '' }] : []),
                ...response.map((occurrenceType) => {
                    return {
                        value: occurrenceType.id!,
                        label: occurrenceType.name
                    };
                })
            ]);
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        if (!authenticatedUser) {
            return;
        }
        getOccurrenceTypes();
    }, [actingBodyId, authenticatedUser]);

    return (
        <FilterDropdown
            label={label ?? translate('occurrenceType')}
            items={items}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            disabled={disabled}
            labelFontSize={labelFontSize}
            labelStyle={labelStyle}
        />
    );
}

export default OccurrenceTypeDropdown;
